var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Expose, plainToInstance, Transform } from 'class-transformer';
import { ModelBookContentSectionContent } from '~/models/model.book.content.section.content';
import { EBookSheetContentType } from '~/shared/types/book-sheet';
export class ModelBookContentSection {
    cdate;
    id;
    mdate;
    order;
    ownerId;
    relativeId;
    sheetId;
    type;
    content;
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ModelBookContentSection.prototype, "cdate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ModelBookContentSection.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ModelBookContentSection.prototype, "mdate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ModelBookContentSection.prototype, "order", void 0);
__decorate([
    Expose({ name: 'owner_id' }),
    __metadata("design:type", Number)
], ModelBookContentSection.prototype, "ownerId", void 0);
__decorate([
    Expose({ name: 'relative_id' }),
    __metadata("design:type", Object)
], ModelBookContentSection.prototype, "relativeId", void 0);
__decorate([
    Expose({ name: 'sheet_id' }),
    __metadata("design:type", Number)
], ModelBookContentSection.prototype, "sheetId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", typeof (_a = typeof EBookSheetContentType !== "undefined" && EBookSheetContentType) === "function" ? _a : Object)
], ModelBookContentSection.prototype, "type", void 0);
__decorate([
    Expose(),
    Transform(({ obj }) => plainToInstance(ModelBookContentSectionContent, obj.content)),
    __metadata("design:type", Array)
], ModelBookContentSection.prototype, "content", void 0);
